import styled from 'styled-components';
import ButtonLoading from '../../../components/ButtonLoading';
import { AnimatedContainer } from '../styles';

export const MainContainer = styled(AnimatedContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const NextStepsButton = styled(ButtonLoading)`
  margin-top: 50px;
  max-width: 281px;
  height: 56px;
`;

export const ImageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  align-items: center;

  img {
    width: 178px;
    height: 200px;
  }
`;

export const TextContainer = styled.div`
  max-width: 382px;

  span {
    font-weight: 500;
    fon-size: 17px;
    line-height: 25px;
    color: ${({ theme }) => theme.colors.grey1};
  }

  margin-top: 54px;

  .middleParagraph {
    margin: 20px 0;
  }

  .highlighted {
    font-weight: 700;
  }

  .emailText {
    font-weight: 700;
    color: ${({ theme }) => theme.colors.darkBlue2};
  }
`;

export const ButtonContainer = styled.div`
  width: 382px;
`;
